import React, { useEffect, useState } from "react";
import { Alert, Stack, Text } from "@mantine/core";
import { getDeviceLogs } from "@utils/api-communication/RestApiCli";
import { DeviceLogEntry, deviceLogSeverity, parseDeviceLogsResponse } from "@utils/deviceLogUtils";
import { deviceLogMessageFormatter } from "@model/DeviceLogs";

export const isErrorLog = (entry: DeviceLogEntry): boolean => deviceLogSeverity(entry) === "error";

interface DeviceLogErrorsProps {
  pid: string;
  scan?: number;
}

const DeviceLogErrors: React.FC<DeviceLogErrorsProps> = ({ pid, scan = 25 }) => {
  const [errors, setErrors] = useState<DeviceLogEntry[]>([]);

  useEffect(() => {
    if (!pid) return;
    let cancelled = false;
    getDeviceLogs(
      pid,
      1,
      scan,
      (response) => {
        if (cancelled) return;
        setErrors(parseDeviceLogsResponse(response).logs.filter(isErrorLog).slice(0, 5));
      },
      () => {
        if (!cancelled) setErrors([]);
      },
    );
    return () => {
      cancelled = true;
    };
  }, [pid, scan]);

  if (errors.length === 0) return null;

  return (
    <Alert color="red" variant="light" title="Errors in the device's recent logs">
      <Stack gap={2}>
        {errors.map((entry, idx) => (
          <Text key={entry._id || idx} size="xs">
            {entry.createdAt ? `${new Date(entry.createdAt).toLocaleString()} — ` : ""}
            {deviceLogMessageFormatter(entry.data ?? "")}
          </Text>
        ))}
      </Stack>
    </Alert>
  );
};

export default DeviceLogErrors;
